module.exports = __webpack_public_path__ + "static/media/perio2.59fbe752.png";